import * as React from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  titleId?: string;
}
const SvgCaretDown = (
  { color = 'currentColor', height = '24px', width = '24px', title, titleId }: SVGRProps,
  ref: Ref<SVGSVGElement>,
): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    ref={ref}
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m11.998 17 7-8h-14l7 8Z" fill="#000" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.998 9h-14l7 8 7-8Zm-4.408 2H9.406l2.592 2.963L14.59 11Z"
      fill={color}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCaretDown);
export default ForwardRef;
